// Auto-generated from Contentful export - DO NOT EDIT MANUALLY
// Generated on: 2026-01-14T06:32:21.752Z

export const whatsNewItemsData = [
  {
    id: 'x6XnKrBzIHvH7eIaziKWS',
    internalTitle: 'Folders and collections',
    title: 'Folders and collections',
    publishedDate: 'August 12, 2025',
    publishedDateRaw: '2025-08-13',
    featureImage: {
      file: {
        url: '/img/contentful/4xCmI51i-folders_and_collections_-_whats_new__1_.webp'
      }
    },
    featureVideo: null,
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Workbooks can now be organized into Folders, and Sheets can be organized into Collections. Adding a Workbook to a Folder or a Sheet to a Collection does not change any data relationships, but allows you to visually sort your data for easier navigation.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Learn how to set up Folders and Collections in our developer docs ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/core-concepts/blueprints#workbook-folders-and-sheet-collections'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'here',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '4k8W1k9ISuAY82K6yOtU2V',
    internalTitle: 'Record flags',
    title: 'Record flags',
    publishedDate: 'August 4, 2025',
    publishedDateRaw: '2025-08-05',
    featureImage: {
      file: {
        url: '/img/contentful/50e7xY66-record_flags_what-s_new.webp'
      }
    },
    featureVideo: null,
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Record flags allow users to select ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'records they want to label or view in a particular way and tag them. These records are still a part of the main dataset, but can be filtered to and actioned as a group.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Learn more about record flags and how to get started in ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://support.flatfile.com/articles/7291813783-record-flags'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'this article',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '40Bs433PyWaddtG3quIZzh',
    internalTitle: 'Reference field filtering',
    title: 'Reference field filtering',
    publishedDate: 'July 23, 2025',
    publishedDateRaw: '2025-07-24',
    featureImage: {
      file: {
        url: '/img/contentful/3Y2DWhD4-what-s_new_-_reference_field_filtering.webp'
      }
    },
    featureVideo: null,
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With reference field filtering, users can now configure dropdown fields that show only relevant options based on the value of another field in the same record.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Learn how to configure your filters in this ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/core-concepts/fields#reference-field-filtering'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'step-by-step guide',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: 'VldsuTUFQrXOCOGEWt0gt',
    internalTitle: 'Prepare',
    title: 'Prepare Agent',
    publishedDate: 'July 21, 2025',
    publishedDateRaw: '2025-07-22',
    featureImage: null,
    featureVideo: {
      video: {
        items: [
          {
            hashed_id: 'ci05ibvfhn',
            id: 136405195,
            duration: 40.768,
            thumbnail: {
              url: 'https://embed-ssl.wistia.com/deliveries/72ce20ebdfc7de59e33c8612c6244198e20bf3fe.jpg?image_crop_resized=200x120',
              width: 200,
              height: 120
            }
          }
        ]
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's new Prepare agent helps you restructure incoming data files so they're easily mapped to your destination schema. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Import any CSV or Excel file and prompt the agent to:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Add, remove, split, combine, or format columns',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Populate columns with calculations of other fields',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Create conditional fields',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Unpivot data (from wide → long)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Learn more about Prepare in the user guide ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://learn.flatfile.io/hubfs/Prepare-user-guide-large.pdf'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '3JqlgpUvPyYYVpwyldpGkM',
    internalTitle: 'Improved developer docs',
    title: 'Improved developer docs',
    publishedDate: 'July 16, 2025',
    publishedDateRaw: '2025-07-17',
    featureImage: null,
    featureVideo: {
      video: {
        items: [
          {
            hashed_id: 'sf2amdx5p2',
            id: 136220170,
            duration: 29.717,
            thumbnail: {
              url: 'https://embed-ssl.wistia.com/deliveries/00256d890ca074009e2cd6d65a9f6e27b1e206b0.jpg?image_crop_resized=200x120',
              width: 200,
              height: 120
            }
          }
        ]
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile’s developer docs have been completely restructured to make it easier to set up and configure Flatfile. The new experience offers a clear, more progressive path for learning, improved navigation, and built-in support for AI and LLM integration.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Ask the on-page AI assistant any product question, open any page in ChatGPT or Claude as context, or copy the page in Markdown to paste in your tool of choice.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Explore the new docs ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/welcome-to-new-docs'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'here',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '57t1KByiC1sxSd0ev6aK0W',
    internalTitle: 'Smart Extract',
    title: 'Smart Extract',
    publishedDate: 'July 14, 2025',
    publishedDateRaw: '2025-07-15',
    featureImage: null,
    featureVideo: {
      video: {
        items: [
          {
            hashed_id: 'si6842uqfd',
            id: 136097025,
            duration: 35.072,
            thumbnail: {
              url: 'https://embed-ssl.wistia.com/deliveries/d8ffd15bd46e9373df0c8cb2a329ea261d5a6e5f.jpg?image_crop_resized=200x120',
              width: 200,
              height: 120
            }
          }
        ]
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Smart Extract is a new agent within Flatfile designed to help you extract structured, usable data from files that don’t follow a standard tabular format. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Smart Extract works with more complex files that contain: ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Global or local metadata',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Multiple header rows',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Multiple tables within a sheet',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Summary or total rows',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Shifted data tables',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Hierarchical data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You’ll be prompted to use Smart Extract when Flatfile detects these characteristics during the initial data upload and extraction process. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Learn more about Smart Extract and how to get started in ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://support.flatfile.com/articles/7144958493-how%20to%20use%20smart%20extract'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'this article',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '3dWClJPx3pvD1LW4JT5h2L',
    internalTitle: 'Saved Transforms',
    title: 'Saved Transforms',
    publishedDate: 'July 7, 2025',
    publishedDateRaw: '2025-07-08',
    featureImage: {
      file: {
        url: '/img/contentful/44hztyQb-saved_transform.webp'
      }
    },
    featureVideo: null,
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Transforms that are applied to your data—whether from the Transform agent's recommendations or by user prompting—can now be saved to reuse on future imports. Any transforms you choose to save will be stored in the Saved Transforms library and can be run individually or all at once to quickly clean and prepare incoming data.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Learn more about Saved Transforms and how to get started in ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://support.flatfile.com/articles/6109299281-How%20to%20use%20Saved%20Transforms%20in%20Flatfile'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'this article',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '6ljuD8LAwVLnSEOY6VFKup',
    internalTitle: 'Inline Transform',
    title: 'Inline Transform',
    publishedDate: 'July 7, 2025',
    publishedDateRaw: '2025-07-08',
    featureImage: {
      file: {
        url: '/img/contentful/36QPDvHD-inline_transform.webp'
      }
    },
    featureVideo: null,
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "You no longer have to visit a separate interface to prompt AI to transform your data. With Inline Transform, you can select the three dots next to any field and type your prompts right there. You'll see a preview of any changes to your data and be able to edit or approve.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Learn more about Inline Transform and how to get started in ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://support.flatfile.com/articles/8127887004-How%20to%20use%20Inline%20Transform%20in%20Flatfile'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'this article',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '6IzNUbtfewOv9nCNk5l7f5',
    internalTitle: 'Analyze & Suggestions',
    title: 'Analyze & Suggestions',
    publishedDate: 'July 7, 2025',
    publishedDateRaw: '2025-07-08',
    featureImage: {
      file: {
        url: '/img/contentful/5DKt7wKI-analyze___suggestions.webp'
      }
    },
    featureVideo: null,
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With the release of Analyze and Suggestions, Flatfile now recommends actions to resolve validation errors and formatting issues in your workbooks.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'When you click ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Analyze',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ', the Transform agent will read your data, consider your schema, validation rules, and prior decisions, and determine where it has enough context to recommend actions.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "As the analysis runs, you'll see sparkle icons appear next to column headers where the agent is proposing actions. Clicking the icon will open the ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Suggestions',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' for that field and allow you to edit, preview, and apply the transform. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Learn more about these features and how to get started in ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://support.flatfile.com/articles/7462518044-How%20to%20use%20Analyze%20and%20Suggestions%C2%A0in%20Flatfile'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'this article',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '5tlpxWkSKfLP3RuZqJzMoX',
    internalTitle: 'MCP server',
    title: 'Flatfile MCP server',
    publishedDate: 'April 29, 2025',
    publishedDateRaw: '2025-04-30',
    featureImage: {
      file: {
        url: '/img/contentful/4NTSdEuL-mcp.webp'
      }
    },
    featureVideo: null,
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Use Flatfile's newly released MCP server with tools like Claude Code, Claude Desktop, and Cursor to interact directly with your Flatfile data. Ask questions, add sheets, create sample data, and more—all with whatever tool you’re most comfortable with.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Learn more about the server and how to get started in ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/learning-center/guides/mcp'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'this guide',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '\n',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '1PKNV1NJHDxwYWOybf3fWB',
    internalTitle: 'Advanced filtering',
    title: 'Advanced filtering',
    publishedDate: 'April 16, 2025',
    publishedDateRaw: '2025-04-17',
    featureImage: {
      file: {
        url: '/img/contentful/2oOkf0O9-advanced_filters__3_.webp'
      }
    },
    featureVideo: null,
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "We've improved our filtering experience within sheets to allow users more control over the data you see. You can now apply both basic and complex filters to view errors, missing values, specific records or values, and more.",
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '3MiJVz5hzwNNSC6vBOkpGD',
    internalTitle: 'Increased retrieval for console logs',
    title: 'Console log updates',
    publishedDate: 'March 30, 2025',
    publishedDateRaw: '2025-03-31',
    featureImage: {
      file: {
        url: '/img/contentful/46VF44RP-console_logs.webp'
      }
    },
    featureVideo: null,
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We now retrieve 5MB of log records for each agent run (previously 4KB) and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'display an error icon in the Agents dashboard next to any runs with issues.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: 'reRCgYjjkZaQ3MtrXfGP0',
    internalTitle: 'Field context menu',
    title: 'Field context menu',
    publishedDate: 'March 24, 2025',
    publishedDateRaw: '2025-03-25',
    featureImage: {
      file: {
        url: '/img/contentful/37Uq9b1W-deterministic_updates__4_.webp'
      }
    },
    featureVideo: null,
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Edit field settings like name, type, description, and required or unique status from our new field context menu. From within Blueprint in Build Mode, click the three dots next to any field to access these options.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '4FW7iIKc05Jbpw3mvbYnkC',
    internalTitle: 'Personal access tokens',
    title: 'Personal access tokens',
    publishedDate: 'March 19, 2025',
    publishedDateRaw: '2025-03-20',
    featureImage: {
      file: {
        url: '/img/contentful/8qJ0OBAE-personal_access_tokens.webp'
      }
    },
    featureVideo: null,
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We’ve just rolled out personal access tokens for Flatfile API access. Unlike shared environment keys, these tokens will follow users across environments, are tied to that user’s permissions, and can be revoked at any time.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/documentation/authentication/account-token#personal-access-tokens'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'You can find the technical documentation here.',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '3fOkRS7B4zWfvqEWjyNxUv',
    internalTitle: 'Insert row',
    title: 'Insert row',
    publishedDate: 'March 17, 2025',
    publishedDateRaw: '2025-03-18',
    featureImage: null,
    featureVideo: {
      video: {
        items: [
          {
            hashed_id: 'nk6e6krnfd',
            id: 131479319,
            duration: 12.0744,
            thumbnail: {
              url: 'https://embed-ssl.wistia.com/deliveries/e7bde548c8b22ccf7b27156e9b8428a53741c8e1.jpg?image_crop_resized=200x120',
              width: 200,
              height: 120
            }
          }
        ]
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You can now hover in between row numbers and click "Insert row" to add a record anywhere in a table.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: [
        {
          sys: {
            type: 'Link',
            linkType: 'Tag',
            id: 'uiImprovement'
          }
        }
      ]
    }
  },
  {
    id: '7Kpl5oJUZkjYiBefWGVq8e',
    internalTitle: 'Add a row button',
    title: 'Button to add a row',
    publishedDate: 'March 11, 2025',
    publishedDateRaw: '2025-03-12',
    featureImage: null,
    featureVideo: {
      video: {
        items: [
          {
            hashed_id: 'dfg2kczz1l',
            id: 131255854,
            duration: 12.0744,
            thumbnail: {
              url: 'https://embed-ssl.wistia.com/deliveries/8f4c2c003044a944cdce3beade47ca3c930a78de.jpg?image_crop_resized=200x120',
              width: 200,
              height: 120
            }
          }
        ]
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "In response to customer feedback, we've released an “add a row” button. You’ll see it frozen at the bottom of any sheet you’re working on, allowing you to quickly click and add a new record without scrolling to the bottom of the dataset.",
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: [
        {
          sys: {
            type: 'Link',
            linkType: 'Tag',
            id: 'uiImprovement'
          }
        }
      ]
    }
  },
  {
    id: '2pLZXFqoYHpqeurTtdYtWw',
    internalTitle: 'Calculations',
    title: 'Calculations',
    publishedDate: 'March 4, 2025',
    publishedDateRaw: '2025-03-05',
    featureImage: null,
    featureVideo: {
      video: {
        items: [
          {
            hashed_id: 'ypbaeen5m7',
            id: 131255856,
            duration: 13.7694,
            thumbnail: {
              url: 'https://embed-ssl.wistia.com/deliveries/8b759b4ea01411f78f7ec332c38658c6946bc654.jpg?image_crop_resized=200x120',
              width: 200,
              height: 120
            }
          }
        ]
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Our new Calculations feature provides deeper insight into your progress toward a complete dataset, displaying count empty, count filled, percent empty, and percent filled metrics by column. \n\n',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'This feature requires activation—please contact your Customer Success Manager to enable it. ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://support.flatfile.com/en/articles/10714991-calculations'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Read more on our Knowledge Base',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    },
    metadata: {
      tags: []
    }
  },
  {
    id: '4S5O15emkME2szc9NJHXgi',
    internalTitle: 'Copy paste ranges',
    title: 'Copy & paste multiple records or values into a range',
    publishedDate: 'February 26, 2025',
    publishedDateRaw: '2025-02-27',
    featureImage: null,
    featureVideo: {
      video: {
        items: [
          {
            hashed_id: 'moa75utffy',
            id: 131272835,
            duration: 20.6667,
            thumbnail: {
              url: 'https://embed-ssl.wistia.com/deliveries/08106239c1bc214c6e98921052f2cbb9e42bf12c.jpg?image_crop_resized=200x120',
              width: 200,
              height: 120
            }
          }
        ]
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Now you can copy multiple values or rows and paste them into a range to have them automatically repeat throughout. This speeds up the data preparation process while minimizing errors, allowing you to move efficiently through a large volume of data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://support.flatfile.com/en/articles/10644463-copy-and-paste-values-or-records'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Read more on our Knowledge Base',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    },
    metadata: {
      tags: [
        {
          sys: {
            type: 'Link',
            linkType: 'Tag',
            id: 'uiImprovement'
          }
        }
      ]
    }
  },
  {
    id: '5kw08J3MeQ7sfFg55FmSqO',
    internalTitle: 'SFTP',
    title: 'Flatfile-hosted SFTP',
    publishedDate: 'February 19, 2025',
    publishedDateRaw: '2025-02-20',
    featureImage: null,
    featureVideo: {
      video: {
        items: [
          {
            hashed_id: 'n2a7018i0v',
            id: 131256065,
            duration: 14.8376,
            thumbnail: {
              url: 'https://embed-ssl.wistia.com/deliveries/8785205abf04f6bfaab637a415bb1aa193b8467c.jpg?image_crop_resized=200x120',
              width: 200,
              height: 120
            }
          }
        ]
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile now offers Flatfile-hosted SFTP, enabling users to upload files via SFTP directly into a designated space. Files uploaded in this way automatically appear in the space and will be extracted, exactly as if you had dropped files onto the Files page.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://support.flatfile.com/en/articles/10604376-sftp'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Read more on our Knowledge Base',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    },
    metadata: {
      tags: [
        {
          sys: {
            type: 'Link',
            linkType: 'Tag',
            id: 'dataMigration'
          }
        },
        {
          sys: {
            type: 'Link',
            linkType: 'Tag',
            id: 'dataSecurity'
          }
        }
      ]
    }
  }
]
